import { render, staticRenderFns } from "./add-school-manager.vue?vue&type=template&id=f546b5b4&scoped=true"
import script from "./add-school-manager.vue?vue&type=script&lang=ts"
export * from "./add-school-manager.vue?vue&type=script&lang=ts"
import style0 from "./add-school-manager.vue?vue&type=style&index=0&id=f546b5b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f546b5b4",
  null
  
)

export default component.exports